// @index('./**/*.tsx', f => `export * from '${f.path}';`)
export * from './HomeTemplate/HomeTemplate';
export * from './NotFoundTemplate/NotFoundTemplate';
export * from './SimpleTemplate/SimpleTemplate';
export * from './TeasingTemplate/TeasingTemplate';
